import { render, staticRenderFns } from "./SubmenuDetail.vue?vue&type=template&id=37d6ea95"
import script from "./SubmenuDetail.vue?vue&type=script&lang=js"
export * from "./SubmenuDetail.vue?vue&type=script&lang=js"
import style0 from "./SubmenuDetail.vue?vue&type=style&index=0&id=37d6ea95&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports